import GameTopLayer from './gameTopLayer'

export default GameTopLayer